import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';


function SigninLink(props) {
    const { loginWithRedirect } = useAuth0();

    const handleLogin = () => {
        try {
            loginWithRedirect({ appState: { returnTo: window.location.pathname } });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <span className='w-50' onClick={handleLogin}>
            { props.children }
        </span>
    )
}

export default SigninLink
